import sanityClient from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

export const client = sanityClient ({
  projectId: 'q0pgol4r',
  dataset: 'production',
  apiVersion: '2022-05-26',
  useCdn: 'true',
  token:'skyIBVErZ255nn2waJmIqUADEgFD2ihxNx48UvR9sA3A424Z3mNNJaoZ7CyRAW3yPpozIusJjvJb0GAcURKmZ2a6DPf2iaaYd8tCSLNP9oQLeXxPgvsHVXgNVGkzaC2iU9gFvqVWI9xUsREZqwGoYOeNRO1Hi9oBhc4kjXVcw0cLTq8FqWn7',
  // process.env.REACT_APP_SANITY_TOKEN,
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source)